export default "__VITE_ASSET__Dkqi4Nws__"